export class IAddressSearchModel {
    address!: String;
    country!: string;
}